import {gql} from '@apollo/client';
import {useMemo} from 'react';

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {UseStepTypeInfosQuery} from './__generated/UseStepTypeInfosQuery';

export const USE_STEP_TYPE_INFOS_QUERY = gql`
  query UseStepTypeInfosQuery @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    automationStepTypeInfos {
      stepType
      groups
      isClonable
      isCopyable
    }
  }
`;

export interface StepTypeInfo {
  groups: Array<string>;
  isClonable: boolean;
  isCopyable: boolean;
}

/**
 * Fetches per-step-type presentation metadata (groups, clone/copy eligibility) from the Domain Graph
 * (automationStepTypeInfos) so the frontend reads it at runtime rather than from a hardcoded
 * build-time map. Returns a lookup keyed by step type; the map is empty while the query is loading.
 */
export default function useStepTypeInfos(): Map<PipelineStepType, StepTypeInfo> {
  const result = useBenchlingQuery<UseStepTypeInfosQuery>(USE_STEP_TYPE_INFOS_QUERY);
  const infos = result.type === QueryResultType.SUCCESS ? result.data.automationStepTypeInfos : undefined;
  return useMemo(() => {
    if (infos === undefined) {
      return new Map();
    }
    return new Map(
      infos.map((info) => [
        info.stepType,
        {groups: info.groups, isClonable: info.isClonable, isCopyable: info.isCopyable},
      ])
    );
  }, [infos]);
}
